<template>
  <section>
    <div class="row">
      <div class="col-12 tab-one-wrapper">
          <form id="filter-charts">
              <div class="row">
                  <div class="col-md-6 mb-3">
                      <label class="font-weight-bold d-block mb-2">Filtro de Projetos</label>
                      <div class="input-group queue-group">
                          <div class="input-group-prepend">
                              <span class="input-group-text icon-wrapper">
                                  <i class="fas fa-layer-group"></i>
                              </span>
                          </div>
                          <div class="multiselect-wrapper">
                              <multiselect v-model="selectedProjects" :options="projects" :multiple="true" :close-on-select="false"
                                  :clear-on-select="false" :hide-selected="false" :preserve-search="false" :preselect-first="false"
                                  :searchable="true" label="name" track-by="id" placeholder="Todos os projetos"
                                  :select-label="'Clique para selecionar'" :deselect-label="'Clique para remover'"
                                  :selected-label="'Selecionado'" :show-no-results="true" @input="onProjectsChange">
                                  <template #noResult>Nenhum projeto encontrado!</template>
                              </multiselect>
                          </div>
                      </div>
                  </div>

                  <div class="col-md-6 mb-3">
                      <label class="font-weight-bold d-block mb-2">Filtro de Filas para os Gráficos</label>
                      <div class="input-group queue-group">
                          <div class="input-group-prepend">
                              <span class="input-group-text icon-wrapper">
                                  <i class="fas fa-chart-bar"></i>
                              </span>
                          </div>
                          <div class="multiselect-wrapper">
                              <multiselect v-model="selectedQueues" :options="queues" :multiple="true" :close-on-select="false"
                                  :clear-on-select="false" :hide-selected="false" :preserve-search="false" :preselect-first="false"
                                  :searchable="false" label="alias" track-by="id" placeholder="Todas as filas"
                                  :select-label="'Clique para selecionar'" :deselect-label="'Clique para remover'"
                                  :selected-label="'Selecionado'" :show-no-results="true" @input="onMultiselectChange">
                                  <template #noResult>Nenhuma fila encontrada!</template>
                              </multiselect>
                          </div>
                      </div>
                  </div>
              </div> 
          </form>
      </div>
      
      <div class="col-12 mt-4">
          <CallsChartInfo ref="callsChartInfo" :filter="chartFilter" :callsInQueue="callsInQueue"
              :callsRinging="callsRinging" :callsInAttendance="callsInAttendanceList.length" :averageWaitTime="avgWaitTime"
              :averageServiceTime="avgServiceTime" />
          <PanelChartInfo :callsInQueueDetails="callsInQueueDetails" :selectedQueues="chartFilter"
              :queueIdToName="queueIdToName" :callsInAttendance="callsInAttendanceRamalCount" :callsRinging="callsRinging"
              :pausedCount="pausedCount" :filteredUsers="filteredUsers" :onlineCount="onlineCount"
              :offlineCount="offlineCount" :averageServiceTime="avgServiceTime" />
          <hr />
      </div>

      <div class="container-fluid">
        <div class="row">
          <!-- Bloco 1: Ligações Atendidas -->
          <div class="col-md-6 mb-4">
            <PizzaChartAnswered :filter="chartFilter" />
          </div>
          
          <!-- Bloco 2: Ligações Abandonadas -->
          <div class="col-md-6 mb-4">
            <PizzaChartAbandoned :filter="chartFilter" />
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12 tab-two-wrapper">
      <div class="wrapper-group">
        <AverageTimeCalls type="serviceTime" :filter="chartFilter" />
        <AverageTimeCalls type="waitingTime" :filter="chartFilter" />
      </div>

      <div>
        <OperatorProductivityChart :filter="chartFilter" />
        <MixedChart :filter="chartFilter" />
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import io from "socket.io-client";
import Multiselect from "vue-multiselect";

import AverageTimeCalls from "../charts/AverageTimeCalls.vue";
import OperatorProductivityChart from "../charts/OperatorProductivityChart.vue";
import CallsChartInfo from "../charts/CallsChartInfo.vue";
import MixedChart from "../charts/MixedChart.vue";
import PizzaChartAnswered from "../charts/PizzaChartAnswered.vue";
import PizzaChartAbandoned from "../charts/PizzaChartAbandoned.vue";
import PanelChartInfo from "../charts/PanelChartInfo.vue";

export default {
  name: "DashboardApp",
  components: {
    AverageTimeCalls,
    OperatorProductivityChart,
    CallsChartInfo,
    MixedChart,
    PizzaChartAnswered,
    PizzaChartAbandoned,
    PanelChartInfo,
    Multiselect,
  },
  data() {
    return {
      toogleRealtime: false,
      intervalId: "",
      callTimer: null,

      queues: [],
      allQueues: [],
      projects: [],
      selectedProjects: [],
      queueIdToName: {},
      selectedQueues: [],
      chartFilter: ["*"],

      callsInQueue: 0,
      callsInAttendanceList: [],
      callsRinging: 0,
      ringingSet: new Set(),
      pausedAgents: new Set(),
      pausedCount: 0,

      avgWaitTime: 0,
      avgServiceTime: 0,

      socketClient: null,
      orToken: null,
      orUrl: process.env.MIX_APP_URL || "https://auster-pabx.advancetelecom.com.br",
      orPort: process.env.MIX_OR_PORT || "3009",
      orUser: process.env.MIX_OR_USERNAME || "Livio",
      orPassword: process.env.MIX_OR_PASSWORD || "operator-realtime-auster",

      updatedCallsMap: new Map(),
      sipStatusMap: new Map(),
      ramalStatusMap: new Map(),
      queueCalls: [],
      usersList: [],

      onlineCount: 0,
      offlineCount: 0,

      isFetchingAttendance: false,
    };
  },
  async created() {
    await this.listQueues();
    await this.listProjects();
    await this.loadUsersList();
    await this.fetchInitialSipStatus();
    await this.fetchInitialQueueCalls();
    await this.updateCallsInAttendance();
    this.loadPausedAgents();
    this.loadRingingSet();
    this.updateRamalStatus();
  },
  mounted() {
    this.setupSocket();
    this.calcCallTimer();
    this.updateAverageTimes();
  },
  computed: {
    callsInAttendanceRamalCount() {
      const extensionSet = new Set(this.usersList.map(u => String(u.extension_line)));
      const activeAgents = new Set();

      this.callsInAttendanceList.forEach(call => {
        const origin = String(call.origin || "");
        const destiny = String(call.destiny || "");

        const originIsUser = extensionSet.has(origin);
        const destinyIsUser = extensionSet.has(destiny);

        if (originIsUser) activeAgents.add(origin);
        if (destinyIsUser) activeAgents.add(destiny);
      });

      return activeAgents.size;
    },

    callsInQueueDetails() {
      let allowedQueues = [];

      if (this.chartFilter.length === 1 && this.chartFilter[0] === "*") {
        allowedQueues = this.queues.map(q => q.name);
      } else {
        allowedQueues = this.chartFilter
          .map(id => this.queueIdToName[id])
          .filter(Boolean);
      }

      return this.queueCalls
        .filter(call => allowedQueues.includes(call.queue))
        .map(call => ({
          number: call.number,
          queue: call.queue,
          waitingTime: call.wait,
        }));
    },

    filteredUsers() {
      if (this.chartFilter.length === 1 && this.chartFilter[0] === "*")
        return this.usersList;

      const selectedQueueNames = this.chartFilter
        .map((id) => this.queueIdToName[id])
        .filter(Boolean);

      return this.usersList.filter((user) => {
        if (!Array.isArray(user.queues)) return false;

        const userQueueNames = user.queues.map(q => q.name);
        return userQueueNames.some((queueName) =>
          selectedQueueNames.includes(queueName)
        );
      });
    },

    filteredCallsInAttendance() {
      if (this.chartFilter.length === 1 && this.chartFilter[0] === "*") {
        return this.callsInAttendanceList;
      }
      const selectedQueueNames = this.chartFilter
        .map((id) => this.queueIdToName[id])
        .filter(Boolean);
      return this.callsInAttendanceList.filter((call) =>
        selectedQueueNames.includes(call.queue)
      );
    },
    callsInAttendance() {
      return this.filteredCallsInAttendance.length;
    },
  },
  watch: {
    filteredUsers: {
      handler() {
        this.updateRamalStatus();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    async handleLoginLogoff(data, type) {
      const user = this.usersList.find(u => String(u.extension_line) === String(data.extension));
      if (!user) return;

      if (!Array.isArray(user.queues)) user.queues = [];

      const alreadyLogged = user.queues.some(q => q.name === data.queue);

      if (type === 'login') {
        if (!alreadyLogged) {
          user.queues.push({ name: data.queue, status: 'logged' });
        }
      } else if (type === 'logoff') {
        user.queues = user.queues.filter(q => q.name !== data.queue);
      }

      this.updateRamalStatus();
    },

    saveRingingSet() {
      try {
        const ringingCalls = Array.from(this.ringingSet)
          .map(uniqueid => {
            const call = this.updatedCallsMap.get(uniqueid);
            if (!call) return null;

            return {
              uniqueid: call.uniqueid,
              origin: this.maskPhoneNumber(call.origin),
              destiny: this.maskPhoneNumber(call.destiny),
              number: this.maskPhoneNumber(call.number),
              timestamp: call.timestamp || Date.now(), // opcional
            };
          })
          .filter(Boolean);

        localStorage.setItem("ringingCalls", JSON.stringify(ringingCalls));
      } catch (e) {
        console.warn("Erro ao salvar chamadas ringing:", e);
      }
    },

    savePausedAgents() {
      try {
        localStorage.setItem("pausedAgents", JSON.stringify([...this.pausedAgents]));
      } catch (e) {
        console.warn("Erro ao salvar agentes pausados:", e);
      }
    },

    loadPausedAgents() {
      try {
        const data = localStorage.getItem("pausedAgents");
        if (data) {
          const list = JSON.parse(data);
          if (Array.isArray(list)) {
            this.pausedAgents = new Set(list);
          }
        }
      } catch (e) {
        console.warn("Erro ao carregar agentes pausados:", e);
      }
    },

    loadRingingSet() {
      try {
        const data = localStorage.getItem("ringingCalls");
        if (data) {
          const list = JSON.parse(data);
          if (Array.isArray(list)) {
            this.ringingSet.clear();
            this.updatedCallsMap = new Map(this.updatedCallsMap); // garante reatividade

            list.forEach(call => {
              if (call?.uniqueid) {
                this.ringingSet.add(call.uniqueid);
                this.updatedCallsMap.set(call.uniqueid, call); // mesmo mascarado, mantém no mapa
              }
            });

            this.callsRinging = this.ringingSet.size;
            this.updateRamalStatus();
          }
        }
      } catch (e) {
        console.warn("Erro ao carregar chamadas ringing:", e);
      }
    },


    async listQueues() {
      try {
        const { data } = await axios.get("dashboard/getQueuesByUser");
        this.allQueues = data || [];
        this.queues = this.allQueues;
        this.selectedQueues = [];
        this.chartFilter = ["*"];
        this.queueIdToName = this.allQueues.reduce((map, queue) => {
          map[queue.id] = queue.name;
          return map;
        }, {});
        if (this.selectedProjects.length) {
          this.applyProjectFilter();
        }
        this.updateCallsInQueueCount();
      } catch (e) {
        console.error("Erro ao listar filas", e);
      }
    },

    async listProjects() {
      try {
        const { data } = await axios.get("/listProjectsByUser");
        this.projects = Array.isArray(data) ? data.map(project => ({
          id: project.id,
          name: project.name,
          queues: Array.isArray(project.queues) ? project.queues.map(String) : [],
        })) : [];
      } catch (e) {
        console.error("Erro ao listar projetos", e);
      }
    },

    onProjectsChange() {
      this.applyProjectFilter();
    },

    applyProjectFilter() {
      if (!this.selectedProjects.length) {
        this.queues = this.allQueues;
        this.selectedQueues = [];
        this.onMultiselectChange();
        return;
      }

      const queueIds = new Set();
      this.selectedProjects.forEach((project) => {
        (project.queues || []).forEach((queueId) => queueIds.add(String(queueId)));
      });

      this.queues = this.allQueues.filter((queue) => queueIds.has(String(queue.id)));
      this.selectedQueues = [...this.queues];
      this.onMultiselectChange();
    },

    onMultiselectChange() {
      this.chartFilter = this.selectedQueues.length
        ? this.selectedQueues.map(q => q.id)
        : ["*"];
      this.updateCallsInQueueCount();
      this.updateAverageTimes();
      this.updateRamalStatus();
    },

    async updateAverageTimes() {
      this.avgWaitTime = await this.fetchAverageWaitTime();
      this.avgServiceTime = await this.fetchAverageServiceTime();
    },

    async fetchAverageWaitTime() {
      try {
        const filterParam = this.chartFilter.join(",");
        const { data } = await axios.get(
          `${window.location.href}/averageWaitingTime?queue=${filterParam}`
        );
        if (Array.isArray(data) && data.length) {
          const total = data.reduce((sum, item) => sum + item.average, 0);
          return Math.round(total / data.length);
        }
      } catch (err) {
        console.error("Erro ao buscar tempo médio de espera:", err);
      }
      return 0;
    },

    async fetchAverageServiceTime() {
      try {
        const filterParam = this.chartFilter.join(",");
        const { data } = await axios.get(
          `${window.location.href}/averageServiceTime?queue=${filterParam}`
        );
        if (Array.isArray(data) && data.length) {
          const total = data.reduce((sum, item) => sum + item.average, 0);
          return Math.round(total / data.length);
        }
      } catch (err) {
        console.error("Erro ao buscar tempo médio de atendimento:", err);
      }
      return 0;
    },

    async loadUsersList() {
      try {
        const response = await axios.get("/list-queues-users");
        if (response.data && Array.isArray(response.data)) {
          this.usersList = response.data;
          this.updateRamalStatus();
        }
      } catch (err) {
        console.error("Erro ao carregar lista de usuários", err);
      }
    },
    maskPhoneNumber(number) {
      if (!number) return "";
      const str = String(number);
      const visibleDigits = 4;
      if (str.length <= visibleDigits) return str;
      const maskedPart = "*".repeat(str.length - visibleDigits);
      const visiblePart = str.slice(-visibleDigits);
      return maskedPart + visiblePart;
    },

    updateRamalStatus() {
      const statusMap = new Map();

      this.pausedAgents.forEach(ext => {
        const isInCall = this.callsInAttendanceList.some(call => {
          const origin = String(call.origin || "");
          const destiny = String(call.destiny || "");
          return origin === ext || destiny === ext;
        });

        if (!isInCall) {
          statusMap.set(String(ext), "paused");
        }
      });

      const extensionSet = new Set(this.usersList.map(u => String(u.extension_line)));

      this.callsInAttendanceList.forEach(call => {
        const origin = String(call.origin || "");
        const destiny = String(call.destiny || "");

        if (extensionSet.has(origin) && statusMap.get(origin) !== "paused") {
          statusMap.set(origin, "inAttendance");
        }
        if (extensionSet.has(destiny) && statusMap.get(destiny) !== "paused") {
          statusMap.set(destiny, "inAttendance");
        }
      });

      this.ringingSet.forEach(uniqueid => {
        const call = this.updatedCallsMap.get(uniqueid);
        if (call) {
          const origin = String(call.origin || "");
          const destiny = String(call.destiny || "");

          if (extensionSet.has(origin) && !statusMap.has(origin)) {
            statusMap.set(origin, "ringing");
          }
          if (extensionSet.has(destiny) && !statusMap.has(destiny)) {
            statusMap.set(destiny, "ringing");
          }
        }
      });

      this.filteredUsers.forEach(user => {
        const ext = String(user.extension_line);
        if (!statusMap.has(ext)) {
          const sipStatus = this.sipStatusMap.get(ext);
          const loggedInQueues = Array.isArray(user.queues) && user.queues.length > 0;
          const finalStatus = sipStatus === true && loggedInQueues ? "online" : "offline";
          statusMap.set(ext, finalStatus);
        }
      });

      this.ramalStatusMap = statusMap;

      let online = 0,
        offline = 0,
        ringing = 0,
        inAttendance = 0;

      for (const [, status] of statusMap.entries()) {
        if (status === "online") online++;
        else if (status === "offline") offline++;
        else if (status === "ringing") ringing++;
        else if (status === "inAttendance") inAttendance++;
      }

      this.onlineCount = online;
      this.offlineCount = offline;
      this.callsRinging = ringing;
      this.callsInAttendanceListCount = inAttendance;

      // --- Novo cálculo de pausados filtrando pelas filas visíveis ---
      const selectedQueueNames = (this.chartFilter.length === 1 && this.chartFilter[0] === "*")
        ? this.queues.map(q => q.name)
        : this.chartFilter.map(id => this.queueIdToName[id]).filter(Boolean);

      this.pausedCount = this.filteredUsers.filter(user => {
        const ext = String(user.extension_line);
        const isPaused = statusMap.get(ext) === "paused";
        return isPaused && user.queues?.some(q => selectedQueueNames.includes(q.name));
      }).length;
    },

    async getAPIToken() {
      try {
        const response = await fetch(`${this.orUrl}:${this.orPort}/generate-token`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ username: this.orUser, password: this.orPassword }),
          credentials: "include",
        });
        const { token } = await response.json();
        if (token) this.orToken = token;
      } catch (e) {
        console.error("Erro ao gerar token", e);
      }
    },

    async fetchInitialQueueCalls() {
      if (!this.orToken) return;
      try {
        const res = await fetch(`${this.orUrl}:${this.orPort}/queue-entry`, {
          headers: { Authorization: `Bearer ${this.orToken}` },
          credentials: "include",
        });
        const data = await res.json();
        if (Array.isArray(data)) {
          data.forEach(item => {
            const call = {
              uniqueid: item.uniqueid,
              number: item.origin || "Desconhecido",
              queue: item.queue || "Desconhecida",
              wait: item.wait || 0,
              position: item.position || 1,
            };
            this.updatedCallsMap.set(item.uniqueid, call);
            this.queueCalls.push(call);
          });
          this.updateCallsInQueueCount();
        }
      } catch (err) {
        console.error("Erro ao buscar chamadas em fila", err);
      }
    },

    async fetchInitialSipStatus() {
      if (!this.orToken) return;
      try {
        const res = await fetch(`${this.orUrl}:${this.orPort}/sip-peers`, {
          headers: { Authorization: `Bearer ${this.orToken}` },
          credentials: "include",
        });
        const data = await res.json();
        if (Array.isArray(data)) {
          this.sipStatusMap.clear();
          data.forEach(({ extension_line, status }) => {
            if (extension_line) {
              this.sipStatusMap.set(String(extension_line), Boolean(status));
            }
          });
          this.updateRamalStatus();
        }
      } catch (err) {
        console.error("Erro ao buscar status inicial dos ramais SIP", err);
      }
    },

    async fetchInitialQueueMembers() {
      if (!this.orToken) return;
      try {
        const res = await fetch(`${this.orUrl}:${this.orPort}/queue-member`, {
          headers: { Authorization: `Bearer ${this.orToken}` },
          credentials: "include",
        });
        const data = await res.json();
        if (Array.isArray(data)) {
          this.queueMembers = data;

          // Não limpar, apenas atualizar baseando nos dados
          this.pausedAgents = new Set(this.pausedAgents);

          data.forEach(member => {
            const ext = member.extension_line || member.extension;
            if (ext && member.paused === true) {
              this.pausedAgents.add(String(ext));
            }
          });

          this.pausedCount = this.pausedAgents.size;
          this.savePausedAgents();
          this.applyQueueMembersToUsers();
          this.updateRamalStatus();
        }
      } catch (err) {
        console.error("Erro ao buscar membros da fila:", err);
      }
    },

    applyQueueMembersToUsers() {
      if (!this.queueMembers.length || !this.usersList.length) return;

      this.usersList.forEach(user => {
        user.queues = [];
      });

      this.queueMembers.forEach(member => {
        const user = this.usersList.find(
          u => String(u.extension_line) === String(member.extension_line)
        );
        if (user) {
          if (!Array.isArray(user.queues)) user.queues = [];
          const alreadyIn = user.queues.some(q => q.name === member.queue);
          if (!alreadyIn) {
            user.queues.push({ name: member.queue, status: 'logged' });
          }
        }
      });
      this.updateRamalStatus();
    },

    async updateCallsInAttendance() {
      if (this.isFetchingAttendance) return;
      this.isFetchingAttendance = true;
      try {
        if (!this.orToken) {
          await this.getAPIToken();
        }
        const res = await fetch(`${this.orUrl}:${this.orPort}/core-show-channels`, {
          headers: { Authorization: `Bearer ${this.orToken}` },
          credentials: "include",
        });
        const data = await res.json();

        if (Array.isArray(data)) {
          const extensionSet = new Set(this.usersList.map(u => String(u.extension_line)));

          this.callsInAttendanceList = data.filter(call => {
            if (call.status !== "active") return false;

            const origin = String(call.origin || "").trim();
            const destiny = String(call.destiny || "").trim();

            const isValidNumber = val => /^[0-9]{2,}$/.test(val);
            const isKnownRamal = extensionSet.has(origin) || extensionSet.has(destiny);

            return isValidNumber(origin) && isValidNumber(destiny) && isKnownRamal;
          });

          const activeUniqueIds = new Set(this.callsInAttendanceList.map(c => c.uniqueid));
          let changed = false;
          this.ringingSet.forEach(uid => {
            if (activeUniqueIds.has(uid)) {
              this.ringingSet.delete(uid);
              changed = true;
            }
          });
          if (changed) {
            this.callsRinging = this.ringingSet.size;
            this.saveRingingSet();
          }
          this.updateRamalStatus();
        }
      } catch (err) {
        console.error("Erro ao atualizar chamadas em atendimento:", err);
      } finally {
        this.isFetchingAttendance = false;
      }
    },

    addRingingCall(uniqueid) {
      if (!this.ringingSet.has(uniqueid)) {
        this.ringingSet.add(uniqueid);
        this.callsRinging = this.ringingSet.size;
        this.saveRingingSet();
        this.updateRamalStatus();
      }
    },

    removeRingingCall(uniqueid) {
      if (this.ringingSet.has(uniqueid)) {
        this.ringingSet.delete(uniqueid);
        this.callsRinging = this.ringingSet.size;
        this.saveRingingSet();
        this.updateRamalStatus();
      }
    },

    isInternalCall(call) {
      const extensionSet = new Set(this.usersList.map(u => String(u.extension_line)));
      const origin = String(call.origin || "");
      const destiny = String(call.destiny || "");
      return extensionSet.has(origin) && extensionSet.has(destiny);
    },

    setupSocket() {
      if (this.socketClient && this.socketClient.connected) {
        this.socketClient.disconnect();
      }
      this.socketClient = io.connect(`${location.protocol}//${location.hostname}:3009`, {
        reconnection: true,
        reconnectionDelay: 2000,
        reconnectionDelayMax: 10000,
        randomizationFactor: 0.5,
        pingTimeout: 600000,
        pingInterval: 120000,
        query: {
          userId: user.getId(),
          userName: user.getName(),
        },
      });

      this.socketClient.on("connect", async () => {
        if (!this.orToken) await this.getAPIToken();
        console.info('[Dashboard] Nova conexão ao server');

        await this.listQueues();
        await this.loadUsersList();
        await this.fetchInitialSipStatus();
        await this.fetchInitialQueueCalls();
        await this.updateCallsInAttendance();
        await this.fetchInitialQueueMembers();

        this.loadRingingSet();

        this.socketClient.on("enteringQueue", data => {
          this.handleCall(data, "entering");

          const uniqueid = data?.uniqueid;
          if (uniqueid) {
            const existing = this.updatedCallsMap.get(uniqueid) || {};
            const updated = {
              ...existing,
              uniqueid,
              origin: data.origin || existing.origin || null,
              destiny: null,
              queue: data.queue || existing.queue || "Desconhecida",
              wait: data.wait || 0,
              position: data.position || 1,
            };

            this.updatedCallsMap.set(uniqueid, updated);

            if (!this.queueCalls.some(c => c.uniqueid === uniqueid)) {
              this.queueCalls.push(updated);
            }
          }
        });

        // this.socketClient.onAny((event, data) => {
        //   console.log("🔔 Evento recebido:", event);
        //   console.log("📦 Dados:", data);
        // });

        this.socketClient.on("agentQueueLogin", data => {
          this.handleLoginLogoff(data, "login");
        });

        this.socketClient.on("agentQueueLogoff", data => {
          this.handleLoginLogoff(data, "logoff");
        });

        this.socketClient.on("leavingQueue", data => {
          const uniqueid = data?.uniqueid;
          if (uniqueid) this.removeRingingCall(uniqueid);
          this.handleCall(data, "leaving");
        });

        this.socketClient.on("ringingCall", async (data) => {
          const uniqueid = data?.uniqueid;
          if (!uniqueid || this.ringingSet.has(uniqueid)) return;

          const call = {
            uniqueid,
            origin: data.origin || null,
            destiny: data.destiny || null,
            number: data.number || null,
            timestamp: Date.now(),
          };

          this.ringingSet.add(uniqueid);
          this.updatedCallsMap.set(uniqueid, call);
          this.saveRingingSet();
          this.callsRinging = this.ringingSet.size;

          // Aguarda a próxima "batida" do Vue para atualizar os ramais corretamente
          this.$nextTick(() => {
            this.updateRamalStatus();
          });
        });


        this.socketClient.on("callInProgress", () => {
          this.updateCallsInAttendance();
        });

        this.socketClient.on("hangup", async (data) => {
          const uniqueid = data?.uniqueid;
          if (!uniqueid) return;

          const isStillInQueue = this.queueCalls.some(c => c.uniqueid === uniqueid);

          // Só remove se não estiver mais na fila
          if (!isStillInQueue) {
            this.updatedCallsMap.delete(uniqueid);
          }

          this.removeRingingCall(uniqueid);
          this.callsRinging = this.ringingSet.size;

          // Forçar contagem correta
          const uniqueQueueCalls = new Map();
          this.queueCalls.forEach(call => {
            uniqueQueueCalls.set(call.uniqueid, call);
          });
          this.queueCalls = Array.from(uniqueQueueCalls.values());

          this.updateCallsInQueueCount();
          await this.updateCallsInAttendance();
        });


        this.socketClient.on("peerStatusUpdate", raw => {
          const data = Array.isArray(raw) ? raw[0] : raw;
          const ext = String(data?.extension);
          if (!ext) return;
          const status = data?.status === true;
          const currentStatus = this.sipStatusMap.get(ext);
          if (currentStatus === status) return;
          this.sipStatusMap.set(ext, status);
          this.updateRamalStatus();
        });

        this.socketClient.on("agentPause", data => {
          if (data?.extension) {
            this.pausedAgents.add(String(data.extension));
            this.savePausedAgents();
            this.updateRamalStatus();
          }
        });

        this.socketClient.on("agentUnpause", data => {
          if (data?.extension && this.pausedAgents.has(String(data.extension))) {
            this.pausedAgents.delete(String(data.extension));
            this.pausedCount = this.pausedAgents.size;
            this.updateRamalStatus();
            this.savePausedAgents();
          }
        });
      });

      this.socketClient.on("disconnect", reason => {
        console.info(`Desconectado: ${reason}`);
        this.callsInQueue = 0;
        this.callsInAttendanceList = [];
        this.callsRinging = 0;
        this.pausedCount = 0;
        this.queueCalls = [];
        this.updatedCallsMap.clear();
        // this.pausedAgents.clear();
        this.sipStatusMap.clear();
        this.onlineCount = 0;
        this.offlineCount = 0;
        this.ringingSet.clear();
        this.ramalStatusMap.clear();
      });

      this.socketClient.on('reconnect_attempt', attemptNumber => {
        console.info(`Tentativa de reconexão #${attemptNumber}`);
      });
    },

    handleCall(data, type) {
      const uniqueid = data.uniqueid;
      const call = this.updatedCallsMap.get(uniqueid);

      if (type === "entering") {
        if (!call) {
          const newCall = {
            uniqueid,
            number: data.origin || data.callerid || "Desconhecido",
            queue: data.queue || "Desconhecida",
            queueId: data.queueId || data.queue,
            wait: data.wait || 0,
            position: data.position || 1,
          };
          this.updatedCallsMap.set(uniqueid, newCall);
          this.queueCalls.push(newCall);
        } else {
          call.wait = data.wait || call.wait;
          call.position = data.position || call.position;
        }
      } else if (type === "leaving") {
        const index = this.queueCalls.findIndex(q => q.uniqueid === uniqueid);
        if (index !== -1) {
          this.queueCalls.splice(index, 1);
          this.updatedCallsMap.delete(uniqueid);
        }
      }
      this.updateCallsInQueueCount();
    },

    updateCallsInQueueCount() {
      let allowedQueues = [];

      if (this.chartFilter.length === 1 && this.chartFilter[0] === "*") {
        allowedQueues = this.queues.map(q => q.name);
      } else {
        allowedQueues = this.chartFilter
          .map(id => this.queueIdToName[id])
          .filter(Boolean);
      }

      this.callsInQueue = this.queueCalls.filter(call =>
        allowedQueues.includes(call.queue)
      ).length;
    },

    calcCallTimer() {
      clearInterval(this.callTimer);
      this.callTimer = setInterval(() => {
        this.queueCalls.forEach(call => {
          call.wait++;
        });
      }, 1000);
    },
  },
  beforeDestroy() {
    if (this.intervalId) clearInterval(this.intervalId);
    if (this.callTimer) clearInterval(this.callTimer);
    if (this.socketClient && this.socketClient.connected) {
      this.socketClient.disconnect();
    }
  },
};
</script>

<style scoped>
@import "~vue-multiselect/dist/vue-multiselect.min.css";

.tab-one-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.wrapper-charts {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

#filter-charts {
  margin-left: 2%;
}

.tab-two-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.sub-group {
  width: 45%;
}

.wrapper-group {
  width: 100%;
  display: flex;
  justify-content: space-around;
}

.toogle-el {
  display: none;
}

.queue-group {
  display: flex;
  align-items: stretch;
  max-width: 50%;
}

.icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 12px;
  background-color: #228899;
  color: white;
  border-radius: 0.25rem 0 0 0.25rem;
  height: 100%;
}

.multiselect-wrapper {
  flex: 1;
}

.multiselect {
  width: 100%;
  font-family: Arial, sans-serif;
  font-size: 14px;
}

.multiselect__tags {
  min-height: 38px;
  height: 100%;
  border-radius: 0 0.25rem 0.25rem 0;
  display: flex;
  align-items: center;
  border: 1px solid #ced4da;
}

.multiselect__select {
  height: 38px;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
}

.multiselect__content-wrapper {
  width: 100% !important;
  box-sizing: border-box;
}
</style>
